export default __webpack_public_path__ + "static/media/navbar.ac889c98.png";